import Config from '@/config'

export default {
	addBodyLink(href) {
		if (document.querySelector("link[href='" + href + "']")) {
			return
		}
		const link = document.createElement('link')
		link.setAttribute('href', href)
		link.setAttribute('rel', 'stylesheet')
		link.setAttribute('type', 'text/css')
		document.body.appendChild(link)
	},
	addBodyScript(src) {
		if (document.querySelector("script[src='" + src + "']")) {
			return
		}
		const script = document.createElement('script')
		script.setAttribute('src', src)
		script.setAttribute('type', 'text/javascript')
		document.body.appendChild(script)
	},
	addHeadLink(href) {
		if (document.querySelector("link[href='" + href + "']")) {
			return
		}
		const link = document.createElement('link')
		link.setAttribute('href', href)
		link.setAttribute('rel', 'stylesheet')
		link.setAttribute('type', 'text/css')
		document.head.appendChild(link)
	},
	addHeadScript(src) {
		if (document.querySelector("script[src='" + src + "']")) {
			return
		}
		const script = document.createElement('script')
		script.setAttribute('src', src)
		script.setAttribute('type', 'text/javascript')
		document.head.appendChild(script)
	},
	deleteLink(href) {
		const el = document.querySelector("link[href='" + href + "']")
		if (el) {
			el.remove()
		}
	},
	deleteScript(src) {
		const el = document.querySelector("script[src='" + src + "']")
		if (el) {
			el.remove()
		}
	},
	getRequestPlanLabelById(id, locale = 'en') {
		if (id === Config.REQUEST_PLAN_FREE) {
			return locale === 'it' ? 'Free' : 'Free'
		}
		if (id === Config.REQUEST_PLAN_BASIC) {
			return locale === 'it' ? 'Basic' : 'Basic'
		}
		if (id === Config.REQUEST_PLAN_PREMIUM) {
			return locale === 'it' ? 'Premium' : 'Premium'
		}
		if (id === Config.REQUEST_PLAN_TOP) {
			return locale === 'it' ? 'Top' : 'Top'
		}
		return '-'
	},
	getRequestStatusLabelById(id, locale = 'en') {
		if (id === Config.REQUEST_STATUS_CLOSED) {
			return locale === 'it' ? 'Chiusa' : 'Closed'
		}
		if (id === Config.REQUEST_STATUS_NEW) {
			return locale === 'it' ? 'Nuova' : 'New'
		}
		if (id === Config.REQUEST_STATUS_WAIT) {
			return locale === 'it' ? 'In corso' : 'Open'
		}
		if (id === Config.REQUEST_STATUS_APPROVED) {
			return locale === 'it' ? 'Approvata' : 'Approved'
		}
		if (id === Config.REQUEST_STATUS_INCOMPLETE) {
			return locale === 'it' ? 'Incompleta' : 'Incomplete'
		}
		if (id === Config.REQUEST_STATUS_REFUNDED) {
			return locale === 'it' ? 'Rimborsata' : 'Refunded'
		}
		if (id === Config.REQUEST_STATUS_RETIRED) {
			return locale === 'it' ? 'Ritirata' : 'Retired'
		}
		return '-'
	},
	getResponseStatusLabelById(id, locale = 'en') {
		if (id === Config.RESPONSE_STATUS_NEW) {
			return locale === 'it' ? 'Nuova' : 'New'
		}
		if (id === Config.RESPONSE_STATUS_PENDING) {
			return locale === 'it' ? 'Pending' : 'Pending'
		}
		if (id === Config.RESPONSE_STATUS_WAIT) {
			return locale === 'it' ? 'In attesa' : 'Wait'
		}
		if (id === Config.RESPONSE_STATUS_KO) {
			return locale === 'it' ? 'Rifiutata' : 'Declined'
		}
		if (id === Config.RESPONSE_STATUS_OK) {
			return locale === 'it' ? 'Accettata' : 'Accepted'
		}
		if (id === Config.RESPONSE_STATUS_APPROVED) {
			return locale === 'it' ? 'Approvata' : 'Approved'
		}
		return '-'
	},
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js